import ShooterGame from '../games/xenowar/js/ShooterGame.js';

window.onload = () => {
    new ShooterGame();
};
